import React, { useEffect, useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import SaveTaskIcon from "@mui/icons-material/Beenhere";
import { hoverScale } from "../../../components/DesignStandardize";

function AddDailyTask() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch existing tasks for a specific date
  const fetchTasksForDate = async (employeeID, date) => {
    try {
      setLoading(true);
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/attendance/allTodayUser/${employeeID}/${date}`;
      const token = localStorage.getItem("jwtToken");
      
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `${token}`,
        },
      });

      // If tasks exist for this date, populate the form
      if (response.data.attendance && response.data.attendance.length > 0) {
        const existingTasks = response.data.attendance[0];
        formik.setValues({
          ...formik.values,
          Date: date,
          Daily_Task1: existingTasks.Daily_Task1 || "",
          Daily_Task2: existingTasks.Daily_Task2 || "",
          Daily_Task3: existingTasks.Daily_Task3 || "",
          Daily_Task4: existingTasks.Daily_Task4 || "",
          Late_Task: existingTasks.Late_Task || "",
        });
      } else {
        // No tasks for this date, clear the form
        formik.setValues({
          ...formik.values,
          Date: date,
          Daily_Task1: "",
          Daily_Task2: "",
          Daily_Task3: "",
          Daily_Task4: "",
          Late_Task: "",
        });
      }
    } catch (error) {
      console.log("Error fetching tasks:", error);
      // If error, just keep the form as is
    } finally {
      setLoading(false);
    }
  };

  // User Info
  useEffect(() => {
    const userString = localStorage.getItem("user");
    if (userString) {
      const userObject = JSON.parse(userString);
      setUser(userObject);
      formik.setValues({
        ...formik.values,
        EmployeeID: userObject.employeeID || "",
      });
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      EmployeeID: user ? user.employeeID : "",
      Date: new Date().toISOString().split("T")[0],
      Daily_Task1: "",
      Daily_Task2: "",
      Daily_Task3: "",
      Daily_Task4: "",
      Late_Task: "",
    },
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/attendance/updatetask`;
        const token = localStorage.getItem("jwtToken");
        
        const response = await axios.post(apiUrl, values, {
          headers: {
            Authorization: `${token}`,
          },
        });

        // Check if response is successful
        if (response.status === 200 || response.status === 201) {
          toast.success("Task updated successfully!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          throw new Error("Unexpected response status");
        }
      } catch (error) {
        console.log("Task update failed:", error.response || error, values);
        
        const errorMessage = error.response?.data?.message || 
                            error.message || 
                            "Failed to add task. Please check your input and try again.";
        
        formik.setStatus(errorMessage);
        toast.error(errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  // Load existing tasks when date changes
  useEffect(() => {
    if (user && formik.values.Date) {
      fetchTasksForDate(user.employeeID, formik.values.Date);
    }
  }, [formik.values.Date, user]);

  // Handle date change
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    formik.setFieldValue("Date", newDate);
  };

  return (
    <>
      <p className="mt-1">Record your daily tasks here...</p>
      {loading && <p className="text-blue-600">Loading existing tasks...</p>}

      {/* {formik.status} */}
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-1 z-0">
        <div className="flex gap-2 items-center mb-3">
          <label className="font-semibold">Select Date:</label>
          <input
            type="date"
            name="Date"
            value={formik.values.Date}
            onChange={handleDateChange}
            className="border-2 border-gray-300 rounded-md px-3 py-1"
          />
        </div>
        
        <table className="w-full text-black">
          <thead>
            <tr className="border-solid border-2 md:sticky md:top-0 z-0 bg-white font-bold text-center">
              <th className="py-2">Time</th>
              <th className="py-2">Daily Task</th>
            </tr>
          </thead>
          <tbody className="border-2 border-solid">
            <tr className="">
              <td className="">
                10:15 a.m to <br /> 12:15 p.m
              </td>
              <td className="  ">
                <textarea
                  label="Task 1"
                  id="Daily_Task1"
                  name="Daily_Task1"
                  type="text"
                  value={formik.values.Daily_Task1}
                  onChange={formik.handleChange}
                  className="w-full min-h-16 bg-white text-black p-2 rounded"
                />
              </td>
            </tr>

            <tr>
              <td className="">
                12:15 p.m to <br /> 2:15 p.m
              </td>
              <td className=" ">
                <textarea
                  label="Task 2"
                  id="Daily_Task2"
                  name="Daily_Task2"
                  type="text"
                  value={formik.values.Daily_Task2}
                  onChange={formik.handleChange}
                  className="w-full min-h-16 bg-white text-black p-2 rounded"
                />
              </td>
            </tr>

            <tr>
              <td>
                2:15 p.m to <br /> 4:15 p.m
              </td>
              <td className=" ">
                <textarea
                  label="Task 3"
                  id="Daily_Task3"
                  name="Daily_Task3"
                  type="text"
                  value={formik.values.Daily_Task3}
                  onChange={formik.handleChange}
                  className="w-full min-h-16 bg-white text-black p-2 rounded"
                />
              </td>
            </tr>

            <tr>
              <td>
                4:15 p.m to <br /> 6:15 p.m
              </td>
              <td className="my-auto">
                <textarea
                  label="Task 4"
                  id="Daily_Task4"
                  name="Daily_Task4"
                  type="text"
                  value={formik.values.Daily_Task4}
                  onChange={formik.handleChange}
                  className="w-full min-h-16 bg-white text-black p-2 rounded"
                />
              </td>
            </tr>

            <tr>
              <td className="">Late Task</td>
              <td className="">
                <textarea
                  label="Late Task"
                  id="Late_Task"
                  name="Late_Task"
                  type="text"
                  value={formik.values.Late_Task}
                  onChange={formik.handleChange}
                  className="w-full min-h-16 bg-white text-black p-2 rounded"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <button
          type="submit"
          disabled={formik.isSubmitting || loading}
          className={`ml-auto p-1 text-white border rounded-lg bg-gradient-to-b from-[#6782e6] to-[#214DED] ${hoverScale} disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          <SaveTaskIcon fontSize="1px" /> {formik.isSubmitting ? "Saving..." : "Save Task"}
        </button>
      </form>
    </>
  );
}

export default AddDailyTask;
